import styled, { css } from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'
import { getToken as getMirandaWCToken } from '@loadsmart/miranda-react/dist/tokens'

export const Card = styled.div`
  background-color: ${getToken('color-neutral-white')};
  border: 1px solid ${getToken('color-neutral-lighter')};
  box-shadow: none;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  font-size: 13px;

  height: 100%;
  justify-content: space-between;

  position: relative;

  transition: box-shadow 0.1s linear, z-index 0.1s linear;

  width: 100%;

  :hover {
    box-shadow: 0 0px 8px ${getToken('color-neutral-lighter')};
  }

  ${props => props.isVip && `border-color: ${getToken('color-neutral-darker')};`};

  ${props => props.isExpired && `cursor: default;`};
`

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;

  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;

  border-radius: 4px;
  box-shadow: none;

  transition: opacity 100ms;

  :hover {
    opacity: 0.7;
  }
`

export const BookButton = styled(Button)`
  color: ${getToken('color-neutral-white')};

  background-color: ${({ daimler_vip }) =>
    daimler_vip ? getToken('color-neutral-dark') : getToken('color-primary')};
  border: 1px solid
    ${({ daimler_vip }) =>
      daimler_vip ? getToken('color-neutral-dark') : getToken('color-primary')};

  :disabled {
    color: ${getToken('color-neutral-light')};

    background-color: ${getToken('color-neutral-lighter')};
    border: 1px solid ${getToken('color-neutral-lighter')};
  }
`

export const BidButton = styled(Button)`
  background-color: ${getToken('color-neutral-white')};
  border: 1px solid ${getToken('color-neutral-darker')};

  color: ${getToken('color-neutral-darker')};

  ${({ activeBid }) =>
    activeBid &&
    css`
      background-color: ${getToken('color-neutral-lighter')};
      border: 1px solid ${getToken('color-neutral-lighter')};
    `};

  :disabled {
    cursor: not-allowed;
    user-select: none;
    border: 1px solid ${getToken('color-neutral-darker')};
    color: ${getToken('color-neutral-darker')};
    opacity: ${getMirandaWCToken('opacity-40')};

    :hover {
      opacity: ${getMirandaWCToken('opacity-40')};
    }
  }
`
